/** 下面两个配合使用 用来在处理过程中把注释拆解出来 */
const COMMENT_KEY = 'TSCOMMENTKEY';
const COMMENT_REPLACE = ';  //';
/** dataSchema的一个字段(非object嵌套) 变成类似ts的类型 */
function dsType2tsType(ds) {
  var _ds$items;
  if (ds.type === 'array' && ds !== null && ds !== void 0 && (_ds$items = ds.items) !== null && _ds$items !== void 0 && _ds$items.type) {
    // 把array里的类型提出来
    return `${ds.items.type}[]`;
  }
  if (Array.isArray(ds.enum)) {
    // : 1 | 2 | 3
    // 把枚举的value提取出来
    const enumStr = ds.enum.map(enumItem => enumItem.value).join('|');
    return enumStr;
  }
  return ds.type || 'any';
}
/** 生成Object 已JSON形式保存有着类似TS interface的结构 */
function dataSchema2TypeJson(ds) {
  const dsObj = {};
  if (!Array.isArray(ds.fields)) return dsObj;
  ds.fields.forEach(fieldItem => {
    // id还能是id? 没id的情况下应该也解析不出东西来吧 不然怎么.进去
    if (!fieldItem.id) return;
    // required false 对应 ?:
    const requiredFalse = fieldItem.required === false ? '?' : '';
    if (!fieldItem.fields) {
      // 到头了 返回个type 注释里附加title和desc信息
      const comment = `${fieldItem.title || ''} ${fieldItem.description || ''}`;
      dsObj[fieldItem.id + requiredFalse] = `${dsType2tsType(fieldItem)}${comment.length > 1 ? `${COMMENT_KEY}${comment}` : ''}`;
    } else {
      // 递归
      dsObj[fieldItem.id + requiredFalse] = dataSchema2TypeJson(fieldItem);
    }
  });
  return dsObj;
}
/** json字符串替换 用来把一个stringify之后的json换成类似 ts interface的形式 */
function typeJson2typescriptInterfaceString(json) {
  // 去掉key的双引号
  let res = json.replace(/"(?=(\S+")?:)/g, '');
  // :后面第一个"
  res = res.replace(/:\s"/g, ': ');
  // :后面最后一个"
  res = res.replace(/"(?=([\s,]+)?\n)/g, '');
  // \"反转译
  res = res.replace(/\\"/g, '"');
  // 偷个懒把注释从value里面拆出来
  res = res.replace(new RegExp(`${COMMENT_KEY}`, 'g'), COMMENT_REPLACE);
  // 去掉行末逗号
  res = res.replace(/,(?=\n)/g, '');
  // markdown换行前来点空格
  res = res.replace(/\n/g, '  \n');
  return res;
}
/** 如果是obj 输出ts interface 如果是其他类型输出类型字符串 如 string[] */
export function dataSchema2TsString(ds, nextLineStr = '\n') {
  const comment = `${ds.title || ''} ${ds.description || ''}`;
  if (ds.fields) {
    // 转到ts的类似interface的格式
    const tsJson = dataSchema2TypeJson(ds);
    const jsonStr = JSON.stringify(tsJson, null, 2);
    const tsStr = typeJson2typescriptInterfaceString(jsonStr);
    if (tsStr.split('\n').length <= 3 && comment.length <= 1) {
      // 小于3行 并且没有title和注释 直接压到一行 然后展示
      return `${tsStr.replace(/\n/g, '')}`;
    }
    const res = tsStr.replace(/\n/g, nextLineStr);
    return res;
  }
  // 到了这里说明是ds根元素的类型不是Object 这样直接返回一个type +注释就行了
  if (!ds.fields) {
    return `${dsType2tsType(ds)}${comment.length > 1 ? ` - ${comment}` : ''}`;
  }
  return '';
}
const tsBlock = str => `\`\`\`typescript\n${str}\n\`\`\``;
/** dataSchema转换为类似ts interface的 Markdown格式 */
export function dataSchema2MarkDown(ds, argKey, {
  expand
} = {
  expand: false
}) {
  const tsStr = dataSchema2TsString(ds);
  if (tsStr.split('\n').length <= 1) {
    // 小于一行的情况下就不用折叠了 直接返回
    // 这时候有两种情况 一种是非object 这时 ds.title ds.description是以注释的形式存在的
    // 如果是object 同时没有 title description 的时候会走这里
    return `\`${argKey}\` : ${tsStr}`;
  }
  const comment = `${ds.title || ''} ${ds.description || ''}`;
  const res = `
<details ${expand ? 'open' : ''} style="margin-bottom: 0">
    <summary>
        <span>
            &nbsp;
        </span>
        <code>${argKey}</code>
        <span>
        <!--   很神奇 不加nbsp就乱掉了     -->
            &nbsp;${comment}
        </span>
    </summary>
    <!-- have to be followed by an empty line! -->

${tsBlock(tsStr)}
</details>`;
  return res;
}
/** 返回多行markdown 来生成对arguments的备注信息 */
export function eventArgs2MarkDown(argumentsSchemas) {
  if (!Array.isArray(argumentsSchemas)) return undefined;
  const res = argumentsSchemas.map((ds, index) => {
    if (index === 0) {
      return dataSchema2MarkDown(ds, '$event');
    }
    return dataSchema2MarkDown(ds, `flow.args[${index}]`);
  }).join('  \n');
  return res;
}
//# sourceMappingURL=generateDataSchemaMarkdown.js.map
